import * as React from 'react';
import { SelectDropdown } from '../../../../internal/components/SelectDropdown';
import { ensureChildrenVisibility, SELECT_ALL_INDEX } from '../../../internal';
import { MultiSelectDesktopDropdownItem } from '../MultiSelectDesktopDropdownItem';
import styles from './styles.module.css';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function MultiSelectDesktopDropdown(props) {
  var open = props.open,
    value = props.value,
    options = props.options,
    name = props.name,
    focusedIndex = props.focusedIndex,
    actions = props.actions,
    onKeyDown = props.onKeyDown,
    allOptionLabel = props.allOptionLabel,
    insideRefs = props.insideRefs;
  var optionsContainerRef = React.useRef(null);
  var focusedOptionRef = React.useRef(null);
  React.useEffect(function () {
    var optionsContainer = optionsContainerRef.current;
    var focusedOption = focusedOptionRef.current;
    if (open && optionsContainer && focusedOption) {
      ensureChildrenVisibility(optionsContainer, focusedOption);
      focusedOption.focus();
    }
  }, [open, focusedIndex]);
  var bindHandleOptionClickIndex = function bindHandleOptionClickIndex(index) {
    return function () {
      actions.toggleOptionState(index);
    };
  };
  var bindHandleOptionMouseMoveIndex = function bindHandleOptionMouseMoveIndex(index) {
    return function () {
      if (focusedIndex !== index) {
        actions.setFocusedIndex(index);
      }
    };
  };
  var allOptionFocused = focusedIndex === SELECT_ALL_INDEX;
  return /*#__PURE__*/_jsx(SelectDropdown, {
    onClose: actions.closeDropdown,
    insideRefs: insideRefs,
    children: /*#__PURE__*/_jsxs("div", {
      ref: optionsContainerRef,
      className: styles['checkbox-group'],
      role: "listbox",
      onKeyDown: onKeyDown,
      children: [allOptionLabel && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(MultiSelectDesktopDropdownItem, {
          ref: allOptionFocused ? focusedOptionRef : undefined,
          value: "allOption",
          label: allOptionLabel,
          name: name,
          focused: allOptionFocused,
          selected: (value === null || value === void 0 ? void 0 : value.length) === options.length,
          onClick: actions.toggleAllOptionState,
          onMouseMove: bindHandleOptionMouseMoveIndex(SELECT_ALL_INDEX)
        }), /*#__PURE__*/_jsx("span", {
          className: styles['divider']
        })]
      }), options.map(function (option, index) {
        var optionValue = option.value;
        var key = String(optionValue);
        var focused = index === focusedIndex;
        var selected = (value || []).includes(optionValue);
        return /*#__PURE__*/_jsx(MultiSelectDesktopDropdownItem, {
          ref: focused ? focusedOptionRef : undefined,
          value: key,
          label: option.label,
          name: name,
          focused: focused,
          selected: selected,
          onClick: bindHandleOptionClickIndex(index),
          onMouseMove: bindHandleOptionMouseMoveIndex(index)
        }, key);
      })]
    })
  });
}